// extracted by mini-css-extract-plugin
export default {"info":"delete-tenant-modal_info__picsE","text":"delete-tenant-modal_text__6IiXd","source":"delete-tenant-modal_source__vuHpr","button":"delete-tenant-modal_button__nG6D4"};